import { useEffect } from 'react';
import { secureApiRequest, API_CONFIG } from '../config/api';

interface VisitorData {
  referrer: string;
  page_url: string;
  screen_resolution: string;
  language: string;
  timezone: string;
}

export const useVisitorTracking = () => {
  useEffect(() => {
    const trackVisit = async () => {
      try {
        // Collect visitor information
        const visitorData: VisitorData = {
          referrer: document.referrer || 'direct',
          page_url: window.location.href,
          screen_resolution: `${screen.width}x${screen.height}`,
          language: navigator.language || 'unknown',
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'unknown'
        };

        // Send tracking data to secure backend
        await secureApiRequest(API_CONFIG.ENDPOINTS.TRACK_VISIT, {
          method: 'POST',
          body: JSON.stringify(visitorData)
        });
      } catch (error) {
        console.warn('Error tracking visit:', error);
      }
    };

    // Track visit when component mounts
    trackVisit();
  }, []);
};

export default useVisitorTracking;